import { ThemeOptions } from '@mui/material/styles';
import { olympicColors as lightColors, breakpoints, olympicFonts1 } from './themeConstants';


const lightTheme: ThemeOptions = {
  palette: {
    mode: 'light',
    primary: {
      main: lightColors.accent,
      dark: '#424D4D'
    },
    secondary: {
      main: '#BDBDBD',
      dark: '#EBECEE',
      contrastText: '#FFFFFF',
    },
    text: {
      primary: lightColors.text,
    },
    common: {
      black: lightColors.text,
      white: '#FFFFFF',
    },
    customBackground: {
      main: lightColors.bg,
      light: '#F4F5F7E5',
    },
    customText: {
      main: lightColors.fieldCaption
    },
    customBorder: {
      main: lightColors.borderHover
    },
    textFieldColors: {
      main: lightColors.textFieldText,
      light: lightColors.textFieldBorder,
      dark: lightColors.textFieldLabel,
    }
  },
  typography: {
    fontFamily: olympicFonts1,
  },
  breakpoints: {
    ...breakpoints
  }
};

export default lightTheme;
